import { render } from "./TalentInfo.vue?vue&type=template&id=5fed7678&scoped=true&ts=true&lang=pug"
import script from "./TalentInfo.vue?vue&type=script&lang=ts"
export * from "./TalentInfo.vue?vue&type=script&lang=ts"

import "./TalentInfo.vue?vue&type=style&index=0&id=5fed7678&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fed7678"]])

export default __exports__